import { Component, OnInit } from '@angular/core';
import { LangService } from '../../core/lang.service';
import { BreadcrumbsService, IBreadcrumbRoute } from '../../core/breadcrumbs.service';
import { getLearnMoreLinks } from '../data/learnmore';
import { LoginGuardService } from '../../api/login-guard.service';

@Component({
  selector: 'applicant-landing',
  templateUrl: './applicant-landing.component.html',
  styleUrls: ['./applicant-landing.component.scss']
})
export class ApplicantLandingComponent implements OnInit {

  breadcrumb:IBreadcrumbRoute[];
  learnMoreLinks = []

  constructor(
    public lang:LangService,
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService
  ) { }

  ngOnInit() {
    this.loginGuard.deactivate();
    this.breadcrumb = [
      this.breadcrumbsService.APPLICANT_LANDING(),
    ];
    this.learnMoreLinks = getLearnMoreLinks(
      this.breadcrumbsService.APPLICANT_LEARNMORE().route+'/',
      this.breadcrumbsService.learnMoreSection.APPLICANT,
    )
  }
}
